import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import {
  IMyOskLectureAttendanceScreenIm,
  IMyOskLectureAttendanceScreenVm,
} from '../my-osk-lecture-attendance-models.model';

/** Shows (or hides) the attendance screen with the QR code on the station where the group's lectures run. */
@Injectable({ providedIn: 'root' })
export class MyOskLectureAttendanceScreenService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MyOskLectureAttendanceScreen`;
  }

  post(myOskLectureAttendanceScreenIm: IMyOskLectureAttendanceScreenIm): Observable<IMyOskLectureAttendanceScreenVm> {
    const headers = this.createHeaders();
    return this.http.post<IMyOskLectureAttendanceScreenVm>(this.baseUrl, myOskLectureAttendanceScreenIm, { headers });
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
